

import {Request} from '@/api/request';
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    editReturnGoodsWarehouse,
    getConstructors,
    getLibraryInfo,
    getOrderCarMountings,
    getOrderCarProject,
    postAddOrderOffer
} from "@/api/http";
import {dateformat} from "@/api/date" ;
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import {useRoute, useRouter} from 'vue-router'
import {validateInput, validateClass} from "@/assets/js/formRules";

type project = {
    id: number;
    project_type_pid: number;
    name: string;
};
type dialogSelect = {
    project_type_pid?: number;
    search?: string;
};
type order = {
    basicset_id: number;
    id: number;
    user_id: number;
    coupon_text: string;
    pay_type: number;
    payment: number;
    order: any;
    order_car: any;
    order_message: any;
    offer: any;
    last_order_id: string;
    next_order_id: string
};
const carcodeColumn: Array<column> = [
    {
        prop: "ordersn",
        label: "单据编号",
        width: 84,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 84,
    },
    
    {
        prop: "category_name",
        label: "车辆型号",
        width: 84,
    },
    {
        prop: "meet_vehicle",
        label: "接车人",
        width: 84,
    },
    {
        prop: "create_time_text",
        label: "开单时间",
        width: 84,
    },
];
const partsColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "配件分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 84,
    },
    {
        prop: "price",
        label: "价格",
        width: 84,
    },
    {
        prop: "stock",
        label: "库存",
        width: 84,
    },
];
const detailColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    {
        prop: "mountings_name",
        label: "编码",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "price",
        label: "单位",
        width: 84,
    },
    {
        prop: "stock",
        label: "报价数量",
        width: 84,
    },
    {
        prop: "stock",
        label: "用料数量",
        width: 84,
    },
    {
        prop: "stock",
        label: "领料",
        width: 84,
    },
    {
        prop: "stock",
        label: "退料",
        width: 84,
    },
];

const coloumList = [
    [
        {
            type: 'lable',
            field: 'name',
            label: '配件名称',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 450,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_type_p_name',
            label: '配件分类',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_unit_name',
            label: '单位',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'cost_price',
            label: '采购单价',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'member',
            label: '数量',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: '',
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'stock_number_',
            label: '已入库',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'stay_number',
            label: '待入库',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'input',
            field: 'stock_number',
            label: '退料',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: 80,
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'return_number',
            label: '退货数量',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: 80,
            estyle: '',
            eclass: ''
        },
    ],
    [
        {
            type: 'button',
            field: 'name',
            label: '配件名称',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 450,
            ewidth: 355,
            estyle: '',
            eclass: ''
        },
        {
            type: 'specification',
            field: 'mountings_type_p_name',
            label: '编码',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_type_pname',
            label: '规格',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: '分类',
            field: 'mountings_type_pname',
            label: '采购单价',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_brand_name',
            label: '品牌',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: '',
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'unit',
            label: '单位',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'number',
            label: '退料',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: 80,
            estyle: '',
            eclass: ''
        },
    ]

]
const return_cash_plan = {
    return_cash_plan: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请选择返现方案"));
                }
            },
            trigger: "blur",
        },
    ],
};
const partsRules = {
    name: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入配件名称", value, callback);
            },
            trigger: "change",
        },
    ],
    price: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入销售价", value, callback);
            },
            trigger: "change",
        },
    ],
    specification: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入规格", value, callback);
            },
            trigger: "change",
        },
    ],
    encoding: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入编码", value, callback);
            },
            trigger: "change",
        },
    ],
    unit_id: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请选择单位"));
                }
            },
            trigger: "blur",
        },
    ],
    ...return_cash_plan,
};

const formRules = {
    type: [{required: true, message: '必填', trigger: 'change'}],
    supplier_id: [{required: true, message: '必填', trigger: 'change'}],
    date: [{required: true, message: '必填', trigger: 'change'}],
}


export default defineComponent({
    name: "editReturnWarehouse",
    components: {editList},
    setup() {
        const setTitle: any = inject("setTitle");
        const headClass = inject("headClass");
        const Router = useRouter();
        let navindex = ref(0),
            uid: any = 0,
            type: any = '',
            dialog_show = reactive({
                parts: false,
                carcode: false
            } as any),
            is_save = ref(false),
            dialog_show_ = ref(""),
            dialogNavIndex = ref(0),
            dialog_search = ref('' as string),
            dialog_isload = ref(false),
            dialog_data = ref([] as Array<any>),
            detailData = reactive([1, 2, 4, 5, 6] as Array<any>),
            serviceForm = ref({
                name: "",
                price: null,
                return_cash_plan: null,
            }),
            partsForm = ref({
                ...serviceForm.value,
                encoding: null,
                specification: "",
                unit_id: null,
            }),
            is_detail = ref(false),
            partsFormNode = ref(null),
            partsTable = ref([]),
            dialogSelect = ref({} as dialogSelect),
            serviceTable = ref([]),
            form = ref({
                type: 0,
                takeaway: null,
                car_order_id: null,
                car_name: null,
                parts: [],
                branch_id: null,
                ordersn: null,
                desc: ""
            } as any),
            is_all = ref(false),
            serviceDialog = ref(false),
            supplierList = ref([] as any),
            orderDetail = ref({offer: [[], []]} as order),
            selectData: Array<project> = [],
            selectList = reactive({
                staff: [],
                branch: [],
                mountings_type_data: [],
                mountings_type_p_data: []
            }),
            is_load = ref(false),
            formRef = ref(null),
            PurchaseManList = ref([] as any),
            
            checkFormData = (): boolean => {
                for (const parts of form.value.parts) {
                    const partsNumber = Number(parts.number);
                    if (partsNumber < 1 || !Number.isInteger(partsNumber)) {
                        alert('出库库数量必须为大于等于1的整数')
                        return false;
                    }
                }
                return true
            },
            _onsubmit = () => {
                if (!checkFormData()) {
                    return;
                }
                is_load.value = true;
                let url = '';
                if (navindex.value == 3) {
                    editReturnGoodsWarehouse({...form.value,id:uid}).then((res:any)=>{
                        is_load.value = false
                        res.status == 202 && Router.go(-1)
                    });
                }
            },
            
            
            getdetail = (id: number) => {
                //门店ID【当为总店时必传】
                let userinfo;
                let user_info = localStorage.getItem('user_info');
                if (user_info) {
                    userinfo = JSON.parse(user_info);
                }
                let data = {};
                if (userinfo.store_id == 0) {
                    data = {
                        store_id: 'store_id',
                        id
                    }
                } else {
                    data = {
                        id
                    }
                }
                getLibraryInfo(data).then((res: any) => {
                    if (res.status == 200) {
                        form.value.branch_id = res.content.info.branch_id;
                        form.value.takeaway = res.content.info.takeaway;
                        form.value.desc = res.content.info.desc;
                        form.value.type = res.content.info.type;
                        form.value.parts = res.content.info.parts_list;
                        form.value.car_order_id = res.content.info.car_order_id;
                        form.value.ordersn = res.content.info.ordersn;
                        if (navindex.value == 1 && form.value.type == '1') {
                            form.value.ordersn = res.content.info.ordersn;
                        } else {
                            form.value.car_name = res.content.info.car_name;
                        }
                    }
                });
            };
        
        
        onMounted(() => {
            
            let title = ''
            is_load.value = true
            
            type = useRoute().query.my_type
                navindex.value = 3
                setTitle(["仓库管理", title]);
                getConstructors({}).then((res: any) => {
                    selectList.staff = res?.content?.staff || []
                    selectList.branch = res?.content?.branch || []
                    is_load.value = false
                });
                let id: any = useRoute().query.uid;
                uid = useRoute().query.uid;
                if (id) {
                    getdetail(id);
                    is_save.value = true;
                }
            });
            
            
            return {
                navindex,
                dialog_show,
                dialogNavIndex,
                partsRules,
                partsForm,
                partsFormNode,
                partsTable,
                dialogSelect,
                serviceForm,
                selectList,
                headClass,
                is_all,
                partsColumn,
                getOrderCarProject,
                serviceDialog,
                orderDetail,
                selectData,
                serviceTable,
                form,
                PurchaseManList,
                supplierList,
                is_load,
                _onsubmit,
                formRef,
                formRules,
                type,
                is_detail,
                detailColumn,
                detailData,
                dialog_isload,
                dialog_data,
                dialog_search,
                dialog_show_,
                coloumList
            };
        },
    });
